// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1QLVu","list":"PatternAutocomplete_list__1ZSnD"};